import { render, staticRenderFns } from "./artist.vue?vue&type=template&id=95d79d58"
import script from "./artist.vue?vue&type=script&lang=js"
export * from "./artist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports